'use strict';

var _$$slick;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

$ = jQuery;

$('.jc-offer-slider').slick((_$$slick = {
  lazyLoad: 'progressive',
  dots: true,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  autoplay: $('.jc-offer-slider iframe').length == 0,
  adaptiveHeight: false
}, _defineProperty(_$$slick, 'lazyLoad', 'ondemand'), _defineProperty(_$$slick, 'responsive', [{
  breakpoint: 1100,
  settings: {
    arrows: false
  }
}]), _$$slick));

//Sticky button mobile
var stickyButton = $('.jc-offer-mobile-stick-button');
var formPosition = $('.jc-offer-form');
if (formPosition.offset()) {
  formPosition = formPosition.offset().top - 40;
}

$(window).scroll(function () {
  var scrollPosition = $(this).scrollTop();

  if (scrollPosition >= formPosition - 600 && !stickyButton.hasClass('hide')) {
    stickyButton.addClass('hide');
  } else if (scrollPosition < formPosition - 600 && stickyButton.hasClass('hide')) {
    stickyButton.removeClass('hide');
  }
});

stickyButton.click(function (event) {
  $('html, body').animate({
    scrollTop: $('.jc-offer-form').offset().top - 40
  }, 1000);
});

//Desabilita comportamento menu principal do Jornal do Carro
$('.jc-nav-wrapper').css('position', 'static');
$('.jc-nav-top-bar').remove();